<template>
  <AppAlerts
    :alerts="alerts"
    @close-alert="removeAlert($event)"
    @show-duplicate-modal="setShowDuplicateModal(true)"
  />
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppAlerts } from '@/stores/app/alerts';
import { useEditor } from '@/stores/editor/editor';

import AppAlerts from './AppAlerts.vue';

export default {
  name: 'AppAlertsProvider',
  components: { AppAlerts },
  computed: {
    ...mapState(useAppAlerts, ['alerts']),
  },
  methods: {
    ...mapActions(useEditor, ['setShowDuplicateModal']),
    ...mapActions(useAppAlerts, ['removeAlert']),
  },
};
</script>
